import removeLocalStorage from './remove-local-storage';

export { removeLocalStorage };

export default removeLocalStorage;
